export enum EVisitRecordType {
  START_PRECHECKIN = 'START_PRECHECKIN',
  PRECHECKIN = 'PRECHECKIN',
  BADGE_GENERATION = 'BADGE_GENERATION',
  DAILY_CHECKIN = 'DAILY_CHECKIN',
  DAILY_CHECKOUT = 'DAILY_CHECKOUT',
  MAXXESS_CHECKIN = 'MAXXESS_CHECKIN',
  MAXXESS_CHECKOUT = 'MAXXESS_CHECKOUT',
  COVID_ACKNOWLEDGEMENT = 'COVID_ACKNOWLEDGEMENT',
  REPRINT_BADGE = 'REPRINT_BADGE',
  BADGE_VALIDITY_CHANGE = 'BADGE_VALIDITY_CHANGE'
}
